module.exports = __webpack_public_path__ + "ca8543ac6b0735b6bfb8cb51d26a06d0.fbx";